var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiCharacterSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 94,
    viewBox: "0 0 98 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.07569e-06 50.8182C-1.16193e-06 72.7091 13.524 86 27.44 86C35.6449 86 41.9425 82.4818 49.96 82.4818C57.9775 82.4818 63.8043 86 70.56 86C77.616 86 98 83.0682 98 50.8182C98 18.5682 79.0125 7.21902e-07 67.032 1.76927e-06C56.9625 2.64957e-06 55.664 7.81819 49.98 7.81819C44.296 7.81819 43.512 3.82545e-06 33.124 4.7336e-06C16.072 6.22434e-06 -4.98946e-06 28.9273 -3.07569e-06 50.8182Z",
    fill: "url(#paint0_radial_657_2729)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4702 80.1997C28.7402 80.1997 22.3547 84.7437 20.9745 90.7498C20.6739 92.0578 21.7881 93.1597 23.1302 93.1597H45.8102C47.1522 93.1597 48.2632 92.0632 48.0376 90.7402C47.0143 84.7389 42.1966 80.1997 35.4702 80.1997Z",
    fill: "url(#paint1_radial_657_2729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0698 80.1997C57.3434 80.1997 52.5257 84.7389 51.5024 90.7402C51.2768 92.0632 52.3878 93.1597 53.7298 93.1597H76.4098C77.7519 93.1597 78.8661 92.0578 78.5655 90.7498C77.1853 84.7437 70.7998 80.1997 64.0698 80.1997Z",
    fill: "url(#paint2_radial_657_2729)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 33,
    rx: 3,
    ry: 5,
    fill: "#162430"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 33,
    rx: 3,
    ry: 5,
    fill: "#162430"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 38.5,
    rx: 2,
    ry: 1.5,
    fill: "#BBEFE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M60.7804 45.0777C60.7603 44.8188 60.7097 44.5634 60.6297 44.3171C60.1798 42.648 58.8141 40.5979 58.1513 39.6668C57.9686 39.4101 57.5969 39.41 57.414 39.6667C56.7506 40.5978 55.382 42.6479 54.9207 44.3171C54.8407 44.5634 54.7901 44.8188 54.7701 45.0777C54.7701 45.1553 54.755 45.2329 54.755 45.3105C54.7511 45.7235 54.8263 46.1333 54.9765 46.5162C55.1267 46.8992 55.3489 47.2478 55.6302 47.5421C55.9116 47.8363 56.2466 48.0703 56.616 48.2307C56.9854 48.3912 57.3819 48.4748 57.7828 48.4768C58.1824 48.4728 58.5773 48.3876 58.9449 48.2263C59.3126 48.065 59.6458 47.8306 59.9256 47.5366C60.2053 47.2426 60.4261 46.8946 60.5754 46.5127C60.7246 46.1307 60.7994 45.7222 60.7954 45.3105C60.7954 45.2329 60.7954 45.1553 60.7804 45.0777Z",
    fill: "#32B6F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_657_2729",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49 36.5) rotate(90) scale(52 59.2558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.600962,
    stopColor: "#BCF0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93DBC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_657_2729",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 84.2497) rotate(90) scale(10.35 21.9938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63DEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#57D1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC7A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_657_2729",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0698 84.2497) rotate(90) scale(10.35 21.9938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63DEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#57D1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC7A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCharacterSad);
export default __webpack_public_path__ + "static/media/ai-character-sad.618e18edaeb4dd7f7b787efea2ab3722.svg";
export { ForwardRef as ReactComponent };